import { render } from "./RenderPanel.vue?vue&type=template&id=5f3e4c54"
import script from "./RenderPanel.vue?vue&type=script&lang=js"
export * from "./RenderPanel.vue?vue&type=script&lang=js"
script.render = render

export default script